import { Component, HostListener, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { Modal } from '../../../models/component/modal.model';
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: true,
})
export class AlertComponent {
  title: InputSignal<string> = input('');
  msg: InputSignal<string> = input('');
  toggle: InputSignal<boolean> = input(false);
  type: InputSignal<Modal.Type> = input<Modal.Type>('info');
  btnText: InputSignal<string> = input('Ok');

  callback: OutputEmitterRef<boolean> = output<boolean>();

  @HostListener('document:keydown.enter', ['$event']) onKeydownValidHandler(event: Event) {
    if (this.toggle()) {
      event.preventDefault();
      this.callback.emit(true);
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: Event) {
    if (this.toggle()) {
      event.preventDefault();
      this.callback.emit(false);
    }
  }

  confirm() {
    this.callback.emit(true);
  }

  cancel() {
    this.callback.emit(false);
  }
}
